import React, { useState } from "react";
import "../Styles/bank.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import TopNav from "../layouts/TopNav";
import { CircularProgress } from "@mui/material";
import ReLoginModal from "../components/ReLoginModal";
import { Link } from "react-router-dom";
import TransportIcon from "../asset/svg/truckIcon";
import api from "../util/axios";

type Bank = {
  code: string;
  name: string;
};

const Transport = () => {
  const [loading, setLoading] = useState(false);
  const token = window.localStorage.getItem("token");

  const [sign, setSign] = useState({
    capacity: "",
    plateNumber: "",
    driver: "",
  });
  const [reLogin, setReLogin] = useState(false);

  const [getBank, setGetBank] = useState<Bank | null>(null);

  const handleChange = ({ target: { name, value } }: any) => {
    if (name === "capacity" && parseInt(value) < 0) {
      value = "0";
    }

    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSubmit = (e: any) => {
    console.log(getBank);
    setLoading(true);
    e.preventDefault();

    api
      .post(
        "/registered-trucks",
        {
          capacity: sign.capacity,
          plateNumber: sign.plateNumber,
          driver: sign.driver,
        },
        {
          headers: headers,
        }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `Truck created and registered successfully.`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setSign({
          capacity: "",
          plateNumber: "",
          driver: "",
        });
        console.log(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setSign({
          capacity: "",
          plateNumber: "",
          driver: "",
        });
        setLoading(false);
      });
  };

  return (
    <div className="board !bg-gray-100">
      <TopNav title="Transport" />

      {reLogin ? <ReLoginModal /> : null}
      <div className="flex justify-between !h-screen p-10 rounded-lg shadow-lg">
        <div className="p-10 !w-6/12 bg-white">
          <div className="flex justify-between flex-start mb-5 ">
            <h1 className="text-2xl text-blue-600">Register Truck</h1>
            <Link to="/dashboard/truckTable">
              <button
                style={{
                  width: "480px",
                  height: "40px",
                  borderRadius: "6px",
                  background: "#0b77c5",
                  border: "none",
                  color: "#fff",
                  fontStyle: "normal",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                View Registered Trucks
              </button>
            </Link>
          </div>
          <hr />
          <form onSubmit={handleSubmit} className="bankInput mt-12 !w-full">
            <div className="input my-6">
              <label>Driver's Name</label>
              <input
                type="text"
                name="driver"
                required
                className="!w-full"
                onChange={handleChange}
                value={sign.driver}
              />
            </div>
            <div className="input my-6">
              <label>Plate Number</label>
              <input
                type="text"
                name="plateNumber"
                required
                className="!w-full"
                onChange={handleChange}
                value={sign.plateNumber}
              />
            </div>
            <div className="input my-6">
              <label>Capacity</label>
              <input
                type="number"
                name="capacity"
                required
                className="!w-full"
                onChange={handleChange}
                value={sign.capacity}
              />
            </div>

            {/* <button type="submit">Register Bank</button> */}
            <button type="submit" className="w-full bg-blue-500 hover:bg-blue-400 text-white font-semibold my-6 py-2 px-4 rounded">
              {loading ? (
                <CircularProgress
                  style={{ color: "#fff", width: "25px", height: "25px" }}
                />
              ) : (
                "Register Truck"
              )}
            </button>
          </form>
        </div>
        <div style={{ backgroundColor: "#99B4C9" }} className="p-10 w-6/12 flex items-center justify-center">
          <TransportIcon />
        </div>
      </div>
    </div>
  );
};

export default Transport;
